import {DceAjax} from "dce-ajax";
import DceAjaxOpenModalAction from "app/lib/ajax/DceAjaxOpenModalAction";
import DceAjaxReplaceElementAction from "app/lib/ajax/DceAjaxReplaceElementAction";
import DceAjaxRemoveElementAction from "app/lib/ajax/DceAjaxRemoveElementAction";
import DceAjaxSetLocalStorageAction from "app/lib/ajax/DceAjaxSetLocalStorageAction";

export {default as ShowMore} from "./components/ShowMore"
export {default as BodyClassToggle} from "./components/BodyClassToggle"
export {default as Modal} from "./components/Modal";
export {default as OpenModal} from "./components/OpenModal"
export {default as AjaxForm} from "./components/AjaxForm"
export {default as Share} from "./components/Share"
export {default as SearchAutocomplete} from "./components/SearchAutocomplete"
export {default as MobileMenu} from "./components/MobileMenu"
export {default as ShowNext} from "./components/ShowNext"
export {default as Filters} from "./components/Filters"
export {default as AjaxBlock} from "./components/AjaxBlock"
export {default as CategoriesMenu} from "./components/CategoriesMenu"
export {default as ManuScreens} from "./components/MenuScreens"
export {default as PaginatorInput} from "./components/PaginatorInput"
export {default as CategoriesColumnsShowMore} from "./components/CategoriesColumnsShowMore"
export {default as Tabs} from "./components/Tabs"
export {default as DataLayerEvents} from "./components/DataLayerEvents"
export {default as CraftvilleTableConfig} from "./components/CraftvilleTableConfig"
export {default as SliderWithValue} from "./components/SliderWithValue"
export {default as ImagesGallery} from "./components/ImagesGallery"
export {default as LocalStorageSyncBlock} from "./components/LocalStorageSyncBlock"
export {default as QuantityInput} from "./components/QuantityInput"
export {default as RegisterPayment} from "./components/RegisterPayment"
export {default as AjaxCallLink} from "./components/AjaxCallLink"
export {default as CustomerForm} from "./components/CustomerForm"
export {default as OrderPage} from "./components/OrderPage"
export {default as PlaceChooser} from "./components/PlaceChooser"

DceAjax.getInstance().registerActionHandler('open_modal', new DceAjaxOpenModalAction());
DceAjax.getInstance().registerActionHandler('replace_element', new DceAjaxReplaceElementAction());
DceAjax.getInstance().registerActionHandler('remove_element', new DceAjaxRemoveElementAction());
DceAjax.getInstance().registerActionHandler('set_local_storage', new DceAjaxSetLocalStorageAction());